(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ff-announcement-bar"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-ff-announcement]').forEach(function(root){
    var slides = root.querySelectorAll('.ff-announcement__slide');
    if (slides.length < 2) return;
    var current = 0;
    var prevBtn = root.querySelector('[data-ff-prev]');
    var nextBtn = root.querySelector('[data-ff-next]');
    var autoplaySpeed = parseInt(root.dataset.autoplay, 10);

    function show(index){
      slides[current].classList.remove('is-active');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('is-active');
    }
    if (nextBtn) nextBtn.addEventListener('click', function(){ show(current + 1); });
    if (prevBtn) prevBtn.addEventListener('click', function(){ show(current - 1); });

    if (autoplaySpeed && !window.matchMedia('(prefers-reduced-motion: reduce)').matches){
      setInterval(function(){ show(current + 1); }, autoplaySpeed * 1000);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-faq-accordion"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-ff-faq-toggle]').forEach(function(btn){
    btn.addEventListener('click', function(){
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      var answer = document.getElementById(btn.getAttribute('aria-controls'));
      btn.setAttribute('aria-expanded', String(!expanded));
      if (expanded){ answer.setAttribute('hidden', ''); } else { answer.removeAttribute('hidden'); }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-header"] && !Shopify.designMode) return;
  try {
    
(function(){
  var header = document.querySelector('[data-ff-header]');
  if (!header) return;
  var menuToggle = header.querySelector('[data-ff-menu-toggle]');
  var mobileNav = header.querySelector('[data-ff-mobile-nav]');
  var searchToggle = header.querySelector('[data-ff-search-toggle]');
  var searchPanel = header.querySelector('[data-ff-search-panel]');

  menuToggle.addEventListener('click', function(){
    var isOpen = mobileNav.hasAttribute('hidden') === false;
    if (isOpen){
      mobileNav.setAttribute('hidden', '');
      menuToggle.setAttribute('aria-expanded', 'false');
    } else {
      mobileNav.removeAttribute('hidden');
      menuToggle.setAttribute('aria-expanded', 'true');
    }
  });

  searchToggle.addEventListener('click', function(){
    var isOpen = searchPanel.hasAttribute('hidden') === false;
    if (isOpen){
      searchPanel.setAttribute('hidden', '');
    } else {
      searchPanel.removeAttribute('hidden');
      searchPanel.querySelector('input').focus();
    }
  });

  document.addEventListener('cart:updated', function(e){
    var countEl = header.querySelector('[data-ff-cart-count]');
    if (countEl && e.detail && typeof e.detail.itemCount !== 'undefined'){
      countEl.textContent = e.detail.itemCount;
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-product-grid"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-ff-quick-add]').forEach(function(btn){
    btn.addEventListener('click', function(){
      var variantId = btn.dataset.variantId;
      if (!variantId) return;
      btn.disabled = true;
      btn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
      .then(function(res){ return res.json(); })
      .then(function(){
        btn.textContent = 'Added ✓';
        document.dispatchEvent(new CustomEvent('cart:updated'));
        setTimeout(function(){ btn.textContent = 'Quick Add'; btn.disabled = false; }, 1500);
      })
      .catch(function(){
        btn.textContent = 'Try Again';
        btn.disabled = false;
      });
    });
  });

  document.querySelectorAll('[data-ff-wishlist]').forEach(function(btn){
    btn.addEventListener('click', function(){
      btn.classList.toggle('is-active');
      btn.textContent = btn.classList.contains('is-active') ? '♥' : '♡';
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-testimonials"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-ff-carousel]').forEach(function(track){
    var section = track.closest('.ff-testimonials');
    var prev = section.querySelector('[data-ff-prev]');
    var next = section.querySelector('[data-ff-next]');
    function scrollByCard(dir){
      var card = track.querySelector('.ff-testimonials__slide');
      if (!card) return;
      track.scrollBy({ left: dir * card.offsetWidth, behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function(){ scrollByCard(-1); });
    if (next) next.addEventListener('click', function(){ scrollByCard(1); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
